import React from "react";

export default function TableBody({ rows, children }) {
  return (
    <tbody className="bg-white divide-y divide-gray-200">
    {rows.map((row, idx) =>
      children ? children(row, idx) : null
    )}
    </tbody>
  );
};
